import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import ListingCard from "@/components/ListingCard";
import { Button } from "@/components/ui/button";

export default function SavedListings() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/saves")
      .then(({ data }) => setItems(data.items || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-10 py-10">
      <div className="overline text-safety">Wishlist</div>
      <h1 className="mt-2 font-display font-black text-4xl tracking-tighter text-forest">Saved listings</h1>
      <p className="mt-2 text-muted-foreground">Items you've hearted for later.</p>

      {loading ? (
        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 gap-4">
          {[...Array(6)].map((_, i) => <div key={i} className="aspect-[4/3] bg-sage animate-pulse" />)}
        </div>
      ) : items.length === 0 ? (
        <div className="mt-10 border border-border bg-white p-16 text-center">
          <div className="font-display text-2xl tracking-tight text-forest">Nothing saved yet</div>
          <p className="mt-2 text-sm text-muted-foreground">Tap the heart on any listing to save it here.</p>
          <Button asChild className="mt-6 rounded-none bg-safety hover:bg-safety-hover text-white h-11 px-6" data-testid="saved-empty-cta">
            <Link to="/listings">Browse listings →</Link>
          </Button>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((l) => <ListingCard key={l.listing_id} listing={l} />)}
        </div>
      )}
    </div>
  );
}
